import { ADMIN_PAGES_KEYS } from '../../../../../../../i18n/constants/keys';
import { SelectOptions } from '../../../../../../../utils/types/react_select_types';

export const QUESTION_TYPES = [
  {
    key: 'number',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.typeNumber,
    defaultLabel: 'Numeric',
    value: 'number',
  },
  {
    key: 'multiple-choice',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.typeMultipleChoice,
    defaultLabel: 'Multiple Choice',
    value: 'multiple-choice',
  },
  {
    key: 'location',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.typeLocation,
    defaultLabel: 'Location',
    value: 'location',
  },
  {
    key: 'text',
    labelKey: ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.typeText,
    defaultLabel: 'Text',
    value: 'text',
  },
] as const;

export const DEFAULT_QUESTION_TYPE = 'number';

export const QUESTION_SEARCH_DEBOUNCE_MS = 600;

export const DEFAULT_PAGE_SIZE = 20;
